import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-content-usage',
  templateUrl: './content-usage.component.html',
  styleUrls: ['./content-usage.component.sass']
})
export class ContentUsageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
